import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

// Gov-br
import { Col, Row } from '@govbr-ds/react-components'

import Sel from './styles-consts'
import Icons from '@/shared/AppIcons'

import { ResumoScope } from '../analise-reacoes.scope'

const styles = {
    flexCenteredLayout: { display: 'flex', alignItems: 'center' },
    flexGrow: { flexGrow: 1 }
} satisfies Record<string, React.CSSProperties>

export type ResumoProps = {
    className?: string
    scope: ResumoScope
}

class ResumoViewClass implements FCClassContext<ResumoProps> {
    scope!: ResumoScope

    render({ className, scope }: ResumoProps) {
        this.scope = scope

        const resumo = scope.data

        return (
            <Row className={clsx(className)}>
                <Col>
                    <div className={Sel.brCard}>
                        <div className={clsx(Sel.brCardContent, Sel.consultaReacoesCardTotalReacoes)}>
                            <div style={styles.flexCenteredLayout}>
                                <span className={clsx(Sel.textBase, Sel.textWeightBold)} style={styles.flexGrow}>
                                    Notificações
                                </span>
                                <img width={16} height={16} src={Icons.trendingUpIconUrl} />
                            </div>
                            <span className={Sel.textUp03}>{resumo.qtdeNotificacoes.valor}</span>
                            <span className={Sel.textDown02}>{resumo.qtdeNotificacoes.reacoes} reações (MedDRA)</span>
                        </div>
                    </div>
                </Col>

                <Col>
                    <div className={Sel.brCard}>
                        <div className={clsx(Sel.brCardContent, Sel.consultaReacoesCardTotalReacoes)}>
                            <div style={styles.flexCenteredLayout}>
                                <span className={clsx(Sel.textBase, Sel.textWeightBold)} style={styles.flexGrow}>
                                    Fora da Bula
                                </span>
                                <img width={16} height={16} src={Icons.circleAlertIconUrl} />
                            </div>
                            <span className={Sel.textUp03}>{resumo.qtdeForaDeBula.valor}</span>
                            <span className={Sel.textDown02}>
                                {resumo.qtdeForaDeBula.reacoes} reações não documentadas
                            </span>
                        </div>
                    </div>
                </Col>

                <Col>
                    <div className={Sel.brCard}>
                        <div className={clsx(Sel.brCardContent, Sel.consultaReacoesCardTotalReacoes)}>
                            <div style={styles.flexCenteredLayout}>
                                <span className={clsx(Sel.textBase, Sel.textWeightBold)} style={styles.flexGrow}>
                                    Não Verificadas
                                </span>
                                <img width={16} height={16} src={Icons.eyeIconUrl} />
                            </div>
                            <span className={Sel.textUp03}>{resumo.qtdeNaoVerificada}</span>
                            <span className={Sel.textDown02}>Modelo não conseguiu verificar</span>
                        </div>
                    </div>
                </Col>

                <Col>
                    <div className={Sel.brCard}>
                        <div className={clsx(Sel.brCardContent, Sel.consultaReacoesCardTotalReacoes)}>
                            <div style={styles.flexCenteredLayout}>
                                <span className={clsx(Sel.textBase, Sel.textWeightBold)} style={styles.flexGrow}>
                                    Pendentes de Verificação
                                </span>
                                <img width={16} height={16} src={Icons.eyeIconUrl} />
                            </div>
                            <span className={Sel.textUp03}>{resumo.qtdePendentesVerificacao}</span>
                            <span className={Sel.textDown02}>Erros de busca ou lacunas</span>
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default classToFComponent(ResumoViewClass)
